import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export const useStoreAuth = create()(
  devtools(
    persist(
      (set) => ({
        isSignedIn: false,
        signIn: () => set((state) => ({ isSignedIn: true })),
        signOut: () => set((state) => ({ isSignedIn: false })),
      }),
      {
        name: "auth-storage",
      },
    ),
  ),
);
